import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { ThemeProvider } from "./context/ThemeContext";
import { AuthProvider } from "./context/AuthContext";
import Landing from "./pages/Landing";
import Admin from "./pages/Admin";
import WritingPage from "./pages/WritingPage";
import ResearchPage from "./pages/ResearchPage";

function App() {
    return (
        <HelmetProvider>
            <ThemeProvider>
                <AuthProvider>
                    <div className="App">
                        <BrowserRouter>
                            <Routes>
                                <Route path="/" element={<Landing />} />
                                <Route path="/admin" element={<Admin />} />
                                <Route path="/writing/:id" element={<WritingPage />} />
                                <Route path="/research/:id" element={<ResearchPage />} />
                            </Routes>
                        </BrowserRouter>
                    </div>
                </AuthProvider>
            </ThemeProvider>
        </HelmetProvider>
    );
}

export default App;
